const PulseIndicator = ({ showIndicator }: { showIndicator: boolean }) => {
  return (
    showIndicator && (
      <>
        <div className="absolute top-[-9px] right-[-9px] rounded-full h-[18px] w-[18px] bg-surface-action-accent-hover p-1" />
        <div className="absolute top-[-5px] right-[-5px] rounded-full h-[10px] w-[10px] bg-surface-action-solid " />
      </>
    )
  );
};

export { PulseIndicator };
